import { useState, useCallback } from "react";

const BBG_FIELDS = [
    "ticker",
    "name",
    "isin",
    "sedol",
    "cusip",
    "eu_composite_ticker",
] as const;
export type BbgFieldName = typeof BBG_FIELDS[number];

export type BbgEditableFields = Record<BbgFieldName, boolean>;

const createFieldState = (value: boolean): BbgEditableFields => ({
    ticker: value,
    name: value,
    isin: value,
    sedol: value,
    cusip: value,
    eu_composite_ticker: value,
});

export const useBbgEditableFields = (initialAllEditable = false) => {
    const [fields, setFields] = useState<BbgEditableFields>(
        createFieldState(initialAllEditable)
    );

    const enableField = useCallback((field: BbgFieldName) => {
        setFields((prev) => ({ ...prev, [field]: true }));
    }, []);

    const enableAll = useCallback(() => {
        setFields(createFieldState(true));
    }, []);

    const disableAll = useCallback(() => {
        setFields(createFieldState(false));
    }, []);

    return {
        fields,
        enableField,
        enableAll,
        disableAll,
    };
};
